import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiPackage, FiShoppingCart, FiTag } from 'react-icons/fi';
import ProductsAdmin from './ProductsAdmin';
import OrdersAdmin from './OrdersAdmin';
import PromoCodesAdmin from './PromoCodesAdmin';

const Admin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('products');

  useEffect(() => {
    // Check if admin is authenticated
    const isAuth = localStorage.getItem('admin_auth');
    if (!isAuth) {
      navigate('/admin/login');
    }

    // Set active tab from hash
    if (location.hash === '#orders') {
      setActiveTab('orders');
    } else if (location.hash === '#promo-codes') {
      setActiveTab('promo-codes');
    }
  }, [location, navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_auth');
    navigate('/admin/login');
  };

  return (
    <div className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tighter text-primary-main" data-testid="admin-heading">
            Admin Panel
          </h1>
          <button
            onClick={handleLogout}
            className="text-sm text-error hover:text-red-700 font-medium"
          >
            Logout
          </button>
        </div>

        {/* Tabs */}
        <div className="flex gap-4 mb-8 border-b border-slate-200">
          <button
            onClick={() => setActiveTab('products')}
            className={`px-6 py-3 font-medium transition-colors relative ${
              activeTab === 'products'
                ? 'text-primary-main'
                : 'text-text-secondary hover:text-text-primary'
            }`}
            data-testid="admin-products-tab"
          >
            <FiPackage className="inline w-5 h-5 mr-2" />
            Products
            {activeTab === 'products' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-main" />
            )}
          </button>
          <button
            onClick={() => setActiveTab('orders')}
            className={`px-6 py-3 font-medium transition-colors relative ${
              activeTab === 'orders'
                ? 'text-primary-main'
                : 'text-text-secondary hover:text-text-primary'
            }`}
            data-testid="admin-orders-tab"
          >
            <FiShoppingCart className="inline w-5 h-5 mr-2" />
            Orders
            {activeTab === 'orders' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-main" />
            )}
          </button>
          <button
            onClick={() => setActiveTab('promo-codes')}
            className={`px-6 py-3 font-medium transition-colors relative ${
              activeTab === 'promo-codes'
                ? 'text-primary-main'
                : 'text-text-secondary hover:text-text-primary'
            }`}
            data-testid="admin-promo-codes-tab"
          >
            <FiTag className="inline w-5 h-5 mr-2" />
            Promo Codes
            {activeTab === 'promo-codes' && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-main" />
            )}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'products' && <ProductsAdmin />}
        {activeTab === 'orders' && <OrdersAdmin />}
        {activeTab === 'promo-codes' && <PromoCodesAdmin />}
      </div>
    </div>
  );
};

export default Admin;
